import { SnfIntlHttpRemoteCall } from '../snf-intl.http-remote-call';

export class GetArticlesRemoteCall extends SnfIntlHttpRemoteCall {
  /**
   * @inheritdoc
   */
  relativePath = 'articles';

  /**
   * The types of artciles to retrieve.
   * (@see src\services\http\remote-calls\snf-api\articles\article.type.js).
   */
  types;

  /**
   * The number of items to retrieve.
   */
  limit;

  /**
   * @inheritdoc
   */
  constructor(language, types = [], limit) {
    super(language);

    this.types = types;
    this.limit = limit;
  }

  cache = true;

  getQuery() {
    return {
      ...super.getQuery(),
      type: this.types.join(','),
      limit: this.limit
    };
  }
}
